/**
 * Creates a sanitizer function that returns the default value if the value is not in the allowed values list.
 * @param allowedValues  The list of allowed values.
 * @param defaultValue The default value to return if the value is not in the allowed values list.
 * @returns The sanitizer function.
 */

export const createSanitizer = <T>(allowedValues: T[], defaultValue: T) => {
  const allowedValuesSet = new Set<T>(allowedValues);

  return <U>(value: U): T => {
    const isAllowedValue = allowedValuesSet.has(value as unknown as T);

    if (isAllowedValue) {
      return value as unknown as T;
    }

    return defaultValue;
  };
};
